module.exports = __webpack_public_path__ + "static/media/Hieu_Pham.2104ecbb.svg";